var _templateObject = _taggedTemplateLiteralLoose(['\n  background-image: url(', ');\n  background-repeat: no-repeat;\n  height: 50px;\n  width: 125px;\n  margin: 10px 0;\n  border: none;\n  background-color: white;\n  &:focus {\n    border: none;\n    outline: none;\n  }\n  input[type=\'file\'] {\n    display: none;\n  }\n  &:hover {\n    background-image: url(', ');\n    cursor: pointer;\n  }\n'], ['\n  background-image: url(', ');\n  background-repeat: no-repeat;\n  height: 50px;\n  width: 125px;\n  margin: 10px 0;\n  border: none;\n  background-color: white;\n  &:focus {\n    border: none;\n    outline: none;\n  }\n  input[type=\'file\'] {\n    display: none;\n  }\n  &:hover {\n    background-image: url(', ');\n    cursor: pointer;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import uploadIcon from '../../../assets/img/uploadIcon.svg';
import uploadIconHover from '../../../assets/img/uploadIconHover.svg';

export var UploadButtonStyled = styled.label(_templateObject, uploadIcon, uploadIconHover);

var UploadButton = function UploadButton(_ref) {
  var name = _ref.name,
      onChange = _ref.onChange,
      className = _ref.className;
  return React.createElement(
    UploadButtonStyled,
    { className: className },
    React.createElement('input', { type: 'file', name: name, onChange: onChange })
  );
};

UploadButton.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.any
} : {};

export default UploadButton;